import classnames from 'classnames';
import { DropdownWrapper } from 'components/shared/Dropdown';
import { useAppSelector } from 'hooks/useAppSelector';
import type { VisibleItem } from 'layouts/main/sp-header/navigation/models';
import type { IntlKey } from 'locales';
import { ReactNode, useMemo } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { FormattedMessage, useIntl } from 'react-intl';
import type { RoutePath } from 'state/router';

import './navigationDropdown.scss';

export type NavigationDropdownProps = {
  associatedRoutes: RoutePath[];
  label: IntlKey;
  children: ReactNode;
  e2e?: string;
  menuE2e?: string;
  toggleE2e?: string;
  title?: IntlKey;
} & VisibleItem;

export function NavigationDropdown({
  associatedRoutes,
  children,
  e2e,
  menuE2e,
  label,
  isVisible = true,
  title,
}: NavigationDropdownProps) {
  const { formatMessage } = useIntl();

  const currentRoute = useAppSelector(state => state.router.path);
  const isActive = useMemo(() => associatedRoutes.includes(currentRoute), [associatedRoutes, currentRoute]);

  if (!isVisible) {
    return null;
  }

  return (
    <DropdownWrapper data-e2e={e2e} openOnHover>
      <Dropdown.Toggle
        className={classnames('navbar-link clickable justify-content-start', { active: isActive })}
        title={title || label ? formatMessage({ id: title ?? label }) : undefined}
      >
        <FormattedMessage id={label} />
      </Dropdown.Toggle>
      <Dropdown.Menu data-e2e={menuE2e}>{children}</Dropdown.Menu>
    </DropdownWrapper>
  );
}
